package com.eladfinish.bible.contest.platform.audio

import com.eladfinish.bible.contest.constants.Constants
import com.russhwolf.settings.Settings
import dev.icerock.moko.resources.FileResource

class SoundService(
    private val soundPlayer: SoundPlayer,
    private val settings: Settings,
) {

    fun playIfAllowed(effect: SoundEffect) =
        playIfSoundEnabled { soundPlayer.play(effect) }

    fun playIfAllowed(fileResource: FileResource) =
        playIfSoundEnabled { soundPlayer.play(fileResource) }

    private inline fun playIfSoundEnabled(block: () -> Unit) {
        if (settings.getBoolean(
                key = Constants.PREF_SOUND_SWITCH,
                defaultValue = true,
            )
        ) {
            block()
        }
    }
}
